import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/badge-checkmark.png'


const _hoisted_1 = { class: "content-box-success" }
const _hoisted_2 = {
  key: 0,
  class: "sign-in"
}
const _hoisted_3 = { class: "content-success" }
const _hoisted_4 = { class: "text-success" }
const _hoisted_5 = {
  key: 0,
  class: "title"
}
const _hoisted_6 = { class: "text-success" }
const _hoisted_7 = {
  key: 0,
  class: "title"
}
const _hoisted_8 = { class: "text-success" }
const _hoisted_9 = {
  key: 0,
  class: "title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createTextVNode("Already have an account? ", -1)),
          _createElementVNode("span", {
            class: "bold",
            onClick: $setup.onSingIn
          }, "Sign in")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        class: "logo-success",
        src: _imports_0
      }, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        (!$setup.isDesktop)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString($props.textData.lineOne.join(" ")), 1))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($props.textData.lineOne, (line) => {
              return (_openBlock(), _createElementBlock("h1", {
                class: "title",
                key: line
              }, _toDisplayString(line), 1))
            }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!$setup.isDesktop)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_7, _toDisplayString($props.textData.lineTwo.join(" ")), 1))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($props.textData.lineTwo, (line) => {
              return (_openBlock(), _createElementBlock("h1", {
                class: "title",
                key: line
              }, _toDisplayString(line), 1))
            }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (!$setup.isDesktop && $props.textData.lineThree)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_9, _toDisplayString($props.textData.lineThree.join(" ")), 1))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($props.textData.lineThree, (line) => {
              return (_openBlock(), _createElementBlock("h1", {
                class: "title",
                key: line
              }, _toDisplayString(line), 1))
            }), 128))
      ])
    ])
  ]))
}